import { Constant } from "../../config";
import axios from "axios";
import { notification } from "antd";

export default {
  getAdminLists: async () => {
    let url = Constant.ADMIN_GETALL_API;

    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const arrayAdminIds = [];
    for (const admin of resp.data.data) {
      arrayAdminIds.push(admin["id"]);
    }

    return { list: resp.data.data, adminIds: arrayAdminIds };
  },
  getCountryList: async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    let rtn = [{ region_code: "NONE", name: "Default" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  },

  getRevisionList: async () => {
    const opt = {
      url: `${Constant.BASE_API}/revision-price?limit=-1`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  },

  searchMemberList: async (string) => {
    const opt = {
      url: `${Constant.BASE_API}/member?search=${string}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  },

  getOfferList: async (page, limit, search) => {
    const opt = {
      url:
        `${Constant.BASE_API}/offer` +
        "?page=" +
        page +
        "&limit=" +
        limit +
        "&search=" +
        search,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data;
  },

  updateStatus: async (id, status) => {
    const opt = {
      url: `${Constant.BASE_API}/offer/status/${id}/${status}`,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data;
  },

  addOffer: async (payload) => {
    const opt = {
      url: `${Constant.BASE_API}/offer`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error };
    }

    return { error: false };
  },

  updateOffer: async (payload) => {
    const opt = {
      url: `${Constant.BASE_API}/offer/update/${payload.id}`,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error };
    }

    return { error: false };
  },
  handlerError: (resp) => {
    let result = false;
    if (resp.error) {
      notification.error({
        message: resp.error.name,
        description: resp.error.description,
      });
    } else {
      result = true;
      notification.success({
        message: "การเพิ่มข้อมูลเสร็จสิ้น",
      });
    }

    return result;
  },
};



// WEBPACK FOOTER //
// ./src/containers/OfferManagement/service.js